import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Select } from '@/components/base/select'
import type { ItemTypeDetailFragment } from '@/gql/graphql'
import { StepActionsContext } from '@/helpers/useTestDefinition'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'
import { useContext } from 'react'

type WireNode = Node<{ name: string, connectorFamilies: ItemTypeDetailFragment['connectorFamilies'], steppable: { connectorFamilyPinAId: string, connectorFamilyPinBId: string } }, 'WireTestStepType'>

export const WireNode = ({ id, data }: NodeProps<WireNode>) => {
  const { changeStep } = useContext(StepActionsContext)

  const connectorFamilyPinOptions = data.connectorFamilies.reduce((acc, connectorFamily) => {
    connectorFamily.connectorFamilyPins.forEach(pin => {
      acc[pin.id] = { value: pin.id, label: `${connectorFamily.name} - ${pin.name}`, detail: pin.role }
    })
    return acc
  }, {} as { [id: string]: { value: string, label: string, detail: string } })

  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-2 gap-2 items-center justify-around h-full">
          <div className="col-span-2 text-center"><Badge color="purple">Wire</Badge></div>
          <Field className="col-span-2">
            <Label>Name</Label>
            <Input value={ data.name } onChange={ e => changeStep(id, { name: e.target.value }) } />
          </Field>
          <Field>
            <Label>Connector pin A</Label>
            <Select value={ data.steppable.connectorFamilyPinAId } onChange={ e => changeStep(id, { steppable: { connectorFamilyPinAId: e.target.value } }) }>
              { Object.values(connectorFamilyPinOptions).map(option => <option value={ option.value }>{ option.label }</option>) }
            </Select>
          </Field>
          <Field>
            <Label>Connector pin B</Label>
            <Select value={ data.steppable.connectorFamilyPinBId } onChange={ e => changeStep(id, { steppable: { connectorFamilyPinBId: e.target.value } }) }>
              { Object.values(connectorFamilyPinOptions).map(option => <option value={ option.value }>{ option.label }</option>) }
            </Select>
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
